{
  "info": "Bilgiler",
  "negative": "Hata",
  "positive": "Başarılı"
}
